module.exports = __webpack_public_path__ + "static/media/category-thumb-big-women-clothing.db013778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/category-thumb-big-women-clothing.jpg
// module id = 2191
// module chunks = 0